import { render, staticRenderFns } from "./Pivot.vue?vue&type=template&id=001b3e49&scoped=true&"
import script from "./Pivot.vue?vue&type=script&lang=js&"
export * from "./Pivot.vue?vue&type=script&lang=js&"
import style0 from "./Pivot.vue?vue&type=style&index=0&id=001b3e49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b3e49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
